import { FetchAuditLogRoutine} from '../redux-routines';

export const initialState = {
  data: [],
  isFetching: false,
  error: null,
};

export const auditListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FetchAuditLogRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchAuditLogRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchAuditLogRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};
